$("#mobile_menu li").each(function () {
    $(this).attr("data-mobile-dropdown-rel") == "by-brand" && $(this).nextAll().wrapAll('<div class="mobile-drop-bottom"></div>');
    var t = $(this).find("a").text(),
        i = $(this).find("a").attr("href");
    t == "800-662-5202" && ($(this).addClass("tel"), $(this).insertAfter($(".mobile-drop-bottom"))), i == "/account" && ($(this).addClass("account"), $(this).find("a").text("My Account"));
}),
$(document).ready(function () {
    $(".cta .team-member__wrap").hover(
        function () {
            $(this).find(".image-element__wrap img").css("transform", "scale(1.2)"),
                $(this).find(".cta-subsection").css("opacity", "1"),
                $(this).find(".cta-subsection").css("max-height", "300px"),
                $(this).find(".team-member__details").addClass("special-hovering");
        },
        function () {
            $(this).find(".cta-subsection").css("max-height", "0"),
                $(this).find(".cta-subsection").css("opacity", "0"),
                $(this).find(".image-element__wrap img").css("transform", "scale(1)"),
                $(this).find(".team-member__details").removeClass("special-hovering");
        }
    );
    getCartandUpdate();
    logoFlipper('flip-box-desktop');
    logoFlipper('flip-box-mobile');
});
$("#AddToCartForm-product-template > form").on("submit", function () {
    setTimeout(getCartandUpdate, 2000);
});
$(document).on("cart.requestComplete", function (event, cart) {
    updateCartNotices(cart.total_price);
});
function getCartandUpdate() {
    console.log("get_cart_update");
    jQuery.ajax({ url: "/cart.js", dataType: "json" }).done(function (data) {
        updateCartNotices(data.items_subtotal_price);
    });
}
function updateCartNotices(cartprice) {
    console.log(cartprice);
    if (1 < cartprice && cartprice < 10000) {
        console.log("< 100");
        var value = (10000 - cartprice) / 100;
        var sentence = "Spend $" + value + " to reach $100 & qualify for free shipping";
        $("#cartNotice").text(sentence);
        $("#cartNotice").show();
        $("#money-left").text(value);
        $(".to-free-shipping").show();
    } else {
        $("#cartNotice").hide();
        $(".to-free-shipping").hide();
    }
}
function description(element) {
    let description = document.querySelector(".shopify-section--product-template .description");
    let buttons = document.querySelector(".description__links");
    if (element == "more") {
        description.classList.remove("description__close");
        buttons.querySelector("button:first-child").style.display = "none";
        buttons.querySelector("button:last-child").style.display = "block";
    } else {
        description.classList.add("description__close");
        buttons.querySelector("button:last-child").style.display = "none";
        buttons.querySelector("button:first-child").style.display = "block";
    }
}

let PlatformLogo = document.querySelector(".R-PlatformLogo");

if(PlatformLogo){
    PlatformLogo.style.display = "none";
}

// Logo Flipper
function logoFlipper(cssClass) {
    console.log('flip')
    let flipBox = document.querySelector('.' + cssClass);
    let isFlipped = false;
  
    // Flip the box every 2 seconds
    setInterval(() => {
        isFlipped = !isFlipped;
        if (isFlipped) {
            flipBox.classList.add('flipped');
        } else {
            flipBox.classList.remove('flipped');
        }
    }, 2000); // 2000 milliseconds = 2 seconds
}